/* eslint-disable prettier/prettier */
import {useGlobalization} from '@Translations';
import {useFormikContext} from 'formik';
import {CompanySettingsFull} from '../utils/GeneralSettingsUtils';
import useSetGeneralSettingsFields from '../utils/useSetGeneralSettingsFields';
import {useDispatch, useSelector} from 'react-redux';
import {getValue} from '@Selectors';
import {
    CurrencyShortCode,
    InputSelect,
} from '@innovyze/stylovyze';
import {CustomInfoCard} from './GeneralSettingsFields.styles';
import React, {ChangeEvent} from 'react';
import {updateCurrentCompanySettings} from '@Actions';

const currencyMap = new Map<string, string>([
    ['USD', 'en-US'],
    ['EUR', 'de-DE'],
    ['AUD', 'en-AU'],
    ['CAD', 'en-CA'],
    ['GBP', 'en-GB'],
    ['JPY', 'ja-JP']
]);

export default function DefaultCurrencySelection() {
    const {t} = useGlobalization();
    const {setValues} = useFormikContext<CompanySettingsFull>();
    const setGeneralSettingsFields = useSetGeneralSettingsFields();
    const companySettingsErrors = useSelector(getValue).companySettings.companySettingsErrors || {};
    const dispatch = useDispatch();

    const setCurrentCurrencyField = (e: ChangeEvent<HTMLInputElement>) => {
        const currency = e.target.value as 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD' | 'JPY';
        setGeneralSettingsFields({
            currencyFormatting: {
                currency: currency,
                shortCode: currencyMap.get(currency) as CurrencyShortCode
            }
        });
        dispatch(updateCurrentCompanySettings({
            currencyFormatting: {
                currency: currency,
                shortCode: currencyMap.get(currency) as CurrencyShortCode
            }
        }));
        setValues(vals => ({
            ...vals,
            currencyFormatting: {currency: currency, shortCode: currencyMap.get(currency) as CurrencyShortCode}
        }));
    };

    return (
        <CustomInfoCard fullHeight title={t('Currency Symbol')}>
            <InputSelect
                menuItems={[
                    {key: 'USD', value: 'USD', label: 'USD'},
                    {key: 'EUR', value: 'EUR', label: 'EUR'},
                    {key: 'GBP', value: 'GBP', label: 'GBP'},
                    { key: 'CAD', value: 'CAD', label: 'CAD' },
                    { key: 'AUD', value: 'AUD', label: 'AUD' },
                    { key: 'JPY', value: 'JPY', label: 'JPY' },
                ]}
                fieldAttrs={{ name: 'currencyFormatting.currency' }}
                selectProps={{ label: t('Currency') }}
                dataCy="currency"
                onChange={setCurrentCurrencyField}
                networkError={companySettingsErrors.currencyFormatting}
            />
        </CustomInfoCard>
    );
}